import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';

import * as NortonActions from './../actions/norton.actions';
import { IEntity } from '@proximus/entity-manager';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { NortonService } from '../../services/norton.service';
import { TechnicalError } from '@dch/products-business-logic';
import { CpvService } from '../../../services/cpv.service';

@Injectable()
export class NortonEffects {
  @Effect()
  productAttributes$: Observable<Action> = this.actions$.pipe(
    ofType(NortonActions.GET_NORTON_PRODUCTS_ATTRIBUTES),
    switchMap((action: NortonActions.GetNortonProductsAttributes) =>
      this.cpvService.getProductsAttributes(action.payload).pipe(
        map(
          (entity: IEntity<any>) =>
            new NortonActions.GetNortonProductsAttributesSuccess(entity.value),
        ),
        catchError((error: IEntity<TechnicalError>) =>
          of(
            new NortonActions.GetNortonProductsAttributesFailed(
              error.errorData as TechnicalError,
            ),
          ),
        ),
      ),
    ),
  );

  @Effect()
  productPrice$: Observable<Action> = this.actions$.pipe(
    ofType(NortonActions.GET_NORTON_PRODUCT_PRICE),
    mergeMap((action: NortonActions.GetNortonProductPrice) =>
      this.cpvService.getProductPrice(action.payload).pipe(
        map(
          (entity: IEntity<any>) =>
            new NortonActions.GetNortonProductPriceSuccess(entity.value),
        ),
        catchError((error: IEntity<TechnicalError>) =>
          of(
            new NortonActions.GetNortonProductPriceFailed(
              error.errorData as TechnicalError,
            ),
          ),
        ),
      ),
    ),
  );

  @Effect()
  nortonAccount$: Observable<Action> = this.actions$.pipe(
    ofType(NortonActions.GET_NORTON_ACCOUNT),
    mergeMap((action: NortonActions.GetNortonAccount) =>
      this.nortonService.getNortonAccountInfo(action.payload).pipe(
        map(
          (entity: IEntity<any>) =>
            new NortonActions.GetNortonAccountSuccess(entity.value),
        ),
        catchError((error: IEntity<TechnicalError>) =>
          of(
            new NortonActions.GetNortonAccountFailed(
              error.errorData as TechnicalError,
            ),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private nortonService: NortonService,
    private cpvService: CpvService,
  ) {}
}
